var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    d: "M42.28 34.7495H26.04C24.4533 29.6161 23.66 24.2961 23.66 18.7895C23.66 13.1895 25.1067 8.75613 28 5.48946C30.9867 2.12946 35.3733 0.449463 41.16 0.449463V8.28946C36.4933 8.28946 34.16 11.1361 34.16 16.8295V19.4895H42.28V34.7495ZM18.62 34.7495H2.38C0.793333 29.6161 0 24.2961 0 18.7895C0 13.1895 1.44667 8.75613 4.34 5.48946C7.32667 2.12946 11.7133 0.449463 17.5 0.449463V8.28946C12.8333 8.28946 10.5 11.1361 10.5 16.8295V19.4895H18.62V34.7495Z",
    fill: "#CBD5E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/“.dfafbd96dfe3e0688e5d037243189648.svg";
export { ForwardRef as ReactComponent };